import { Box } from "@nulogy/components";
import { formatEfficiency } from "components/helpers/format";
import LineTypeTag from "components/pages/schedule/LineTypeTag";
import React from "react";
import styled, { css } from "styled-components";
import ReadOnlyName from "./ReadOnlyName";

const evenLineLabel = css`
  background-color: white;
`;

const oddLineLabel = css`
  background-color: #f4f5f7;
`;

const LineLabel = styled.div`
  align-self: start;
  height: 100%;
  width: 100%;
  ${({ index }) => (index % 2 === 0 ? evenLineLabel : oddLineLabel)};
`;

const Efficiency = styled.div(({ theme }) => ({
  fontSize: theme.fontSizes.smaller,
  fontWeight: theme.fontWeights.normal,
}));

export default function Line({ cellElement, record }) {
  cellElement.className = `${cellElement.className} schedule-line-cell`;

  if (record.data.id === "shifts") {
    return null;
  }

  const { efficiency } = record.data;

  return (
    <LineLabel className={`line-label line-${record.id} spec-line-${record.id}`} index={record.parentIndex}>
      <Box marginLeft="5px" marginTop="8px">
        <Box paddingBottom="2px">
          <ReadOnlyName data-testid="line">{record.name}</ReadOnlyName>
        </Box>

        <Box paddingBottom="2px">
          <LineTypeTag>{record.lineType}</LineTypeTag>
        </Box>
        <Box paddingBottom="2px">
          <Efficiency>{formatEfficiency(efficiency)}</Efficiency>
        </Box>
      </Box>
    </LineLabel>
  );
}
